import React, { useState } from 'react';
import DataTable from '../../../components/DataTable';
import EditModal from '../../../components/EditModal';
import { editDonorSchema } from '../../../formData/editDonorSchema';
import { showSuccess } from '../../../components/showSuccess';
import Tooltip from '../../../components/Tooltip';
import DownClickablePopup from '../../../components/DownClickablePopup';
import DynamicForm from '../../../components/dynamicForm';
import { donationFilterSchema } from '../../../formData/donationFilterSchema';
import { Link } from 'react-router-dom';

let sampleData = [
   {
      id: 'P001',
      title: 'Program 01',
      imageUrl: 'https://picsum.photos/seed/1/100/60',
      dateOfProgram: '04/08/2025 08:00am',
      description: 'Lorem ipsum dolor sit amet consectetur.',
      type: 'Programs',
      acceptedPaymentType: 'One Time',
      subscribers: 120,
      slug: 'Program01',
      status: 'Active',
      statusColor: '#c8e6c9', // Green for Active
   },
   {
      id: 'P002',
      title: 'Program 02',
      imageUrl: 'https://picsum.photos/seed/2/100/60',
      dateOfProgram: '05/10/2025 10:30am',
      description: 'Sed do eiusmod tempor incididunt.',
      type: 'Events',
      acceptedPaymentType: 'Recurring',
      subscribers: 85,
      slug: 'Program02',
      status: 'Inactive',
      statusColor: '#ffcdd2', // Red for Inactive
   },
   {
      id: 'P003',
      title: 'Program 03',
      imageUrl: 'https://picsum.photos/seed/3/100/60',
      dateOfProgram: '06/12/2025 02:15pm',
      description: 'Ut labore et dolore magna aliqua.',
      type: 'Services',
      acceptedPaymentType: 'One Time',
      subscribers: 45,
      slug: 'Program03',
      status: 'Active',
      statusColor: '#c8e6c9',
   },
   {
      id: 'P004',
      title: 'Program 04',
      imageUrl: 'https://picsum.photos/seed/4/100/60',
      dateOfProgram: '07/20/2025 09:00am',
      description: 'Quis ipsum suspendisse ultrices gravida.',
      type: 'Programs',
      acceptedPaymentType: 'Recurring',
      subscribers: 200,
      slug: 'Program04',
      status: 'Active',
      statusColor: '#c8e6c9',
   },
   {
      id: 'P005',
      title: 'Program 05',
      imageUrl: 'https://picsum.photos/seed/5/100/60',
      dateOfProgram: '08/15/2025 11:45am',
      description: 'Risus commodo viverra maecenas accumsan.',
      type: 'Events',
      acceptedPaymentType: 'One Time',
      subscribers: 75,
      slug: 'Program05',
      status: 'Inactive',
      statusColor: '#ffcdd2',
   },
];

export default function ProgrammeListPage(props) {
   const { pageTitle = "Programs" } = props; // Fixed typo: paggeTitle -> pageTitle
   const [search, setSearch] = useState('');
   const [modalVisible, setModalVisible] = useState(false);
   const [editData, setEditData] = useState({});
   const [sortOption, setSortOption] = useState(null);
   const [filterOption, setFilterOption] = useState(null);



   const sortOptions = [
      'Date of Program - Ascending',
      'Date of Program - Descending',
      'Subscribers - Ascending',
      'Subscribers - Descending',
   ];

   const filterOptions = [
      'All Statuses',
      'Active',
      'Inactive',
   ];

   const handleSortChange = (option) => {
      setSortOption(option);
   };

   const handleFilterChange = (option) => {
      setFilterOption(option);
   };

   const sortedData = [...sampleData].sort((a, b) => {
      if (!sortOption) return 0;
      switch (sortOption) {
         case 'Date of Program - Ascending':
            return new Date(a.dateOfProgram) - new Date(b.dateOfProgram);
         case 'Date of Program - Descending':
            return new Date(b.dateOfProgram) - new Date(a.dateOfProgram);
         case 'Subscribers - Ascending':
            return a.subscribers - b.subscribers;
         case 'Subscribers - Descending':
            return b.subscribers - a.subscribers;
         default:
            return 0;
      }
   });

   const filteredData = sortedData
      .filter(d => {
         if (!filterOption || filterOption === 'All Statuses') return true;
         return d.status === filterOption;
      })
      .filter(d =>
         d.title.toLowerCase().includes(search.toLowerCase()) // Fixed: d.key -> d.title
      );

   const columns = [
      { key: 'title', title: 'TITLE' },
      {
         key: 'imageUrl',
         title: 'IMAGE',
         render: (url) => (
            <img
               src={url}
               alt=""
               style={{ width: 100, height: 60, objectFit: 'cover', borderRadius: 4 }}
            />
         ),
      },
      { key: 'dateOfProgram', title: 'DATE OF PROGRAM' },
      { key: 'description', title: 'DESCRIPTION' },
      { key: 'type', title: 'TYPE' },
      { key: 'acceptedPaymentType', title: 'ACCEPTED PAYMENT TYPE' },
      { key: 'subscribers', title: 'SUBSCRIBERS' },
      {
         key: 'slug',
         title: 'SLUG',
         render: (slug) => (
            <Link to={`/programs/${slug}`} style={{ color: '#007bff', textDecoration: 'none' }}>
               {`/${slug}`}
            </Link>
         ),
      },
      {
         key: 'status',
         title: 'STATUS',
         render: (status, row) => (
            <div className="flex items-center">
               <span
                  style={{
                     display: 'inline-block',
                     padding: '4px 8px',
                     borderRadius: 12,
                     fontSize: 12,
                     backgroundColor: row.statusColor,
                     marginLeft: 8,
                  }}
               >
                  {status}
               </span>
            </div>
         ),
      },
      {
         key: 'actions',
         title: 'ACTION',
         render: (_, row) => (
            <div>
               <button
                  title="Edit"
                  style={styles.actionBtn}
                  onClick={() => handleEdit(row)} // Added onClick handler
               >
                  <span className="material-icons">edit</span>
               </button>
               <button title="View" style={styles.actionBtn}>
                  <span className="material-icons">visibility</span>
               </button>
               <button title="Copy Slug" style={styles.actionBtn}>
                  <span className="material-icons">content_copy</span>
               </button>
            </div>
         ),
      },
   ];

   const handleEdit = (row) => {
      setEditData(row);
      setModalVisible(true);
   };

   const handleClose = () => {
      setModalVisible(false);
   };

   const handleUpdate = async (updatedRow) => {
      console.log('Updated row:', updatedRow);
      setModalVisible(false);
      await showSuccess('Program Details Updated Successfully!');
   };

   const sortHtml = sortOptions.map((option, index) => (
      <div
         key={index}
         className={`sort-option ${sortOption === option ? 'sort-option-selected' : ''}`}
         onClick={() => handleSortChange(option)}
      >
         <span className="sort-option-radio"></span>
         <span>{option}</span>
      </div>
   ));

   const filterHtml = filterOptions.map((option, index) => (
      <div
         key={index}
         className={`sort-option ${filterOption === option ? 'sort-option-selected' : ''}`}
         onClick={() => handleFilterChange(option)}
      >
         <span className="sort-option-radio"></span>
         <span>{option}</span>
      </div>
   ));

   return (
      <>
         <EditModal
            visible={modalVisible}
            schema={editDonorSchema}
            initialData={editData}
            onClose={handleClose}
            onSubmit={handleUpdate}
         />
         <div style={styles.container}>
            <div style={styles.toolbar}>
               <h1 style={styles.title}>{pageTitle}</h1>
               <div style={styles.rightSideFilter}>
                  <div style={styles.searchWrapper}>
                     <span className="material-icons" style={styles.searchIcon}>
                        search
                     </span>
                     <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={styles.searchInput}
                     />
                  </div>
                  <DownClickablePopup popUpTitle={'Filter'} filters={filterHtml}>
                     <button style={styles.iconBtn}>
                        <span className="material-icons">filter_list</span>
                     </button>
                  </DownClickablePopup>
                  <DownClickablePopup popUpTitle={'Sort'} filters={sortHtml}>
                     <button style={styles.iconBtn}>
                        <span className="material-icons">sort</span>
                     </button>
                  </DownClickablePopup>
               </div>
            </div>
            <div style={styles.statusFilterBar}>
               <div style={{...styles.statusFilterBarButton, ...styles.activeTab}}>Active</div>
               <div style={styles.statusFilterBarButton}>Inactive</div>
               <div style={styles.statusFilterBarButton}>Archived</div>
            </div>
            <DataTable data={filteredData} columns={columns} rowKey="id" />
         </div>
      </>
   );
}

const styles = {
   statusFilterBar: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '0px 16px',
      backgroundColor: 'rgb(255, 255, 255)',
      borderRadius: '4px 4px 0px 0px',
      borderTop: '1px solid rgb(204, 204, 204)',
      borderRight: '1px solid rgb(204, 204, 204)',
      borderLeft: '1px solid rgb(204, 204, 204)',
      borderImage: 'initial',
      borderBottom: 'none',
      gap: '10px',
   },
   statusFilterBarButton:{
      textAlign: 'center',
      padding: '10px 10px',
      fontSize: '15px',
      borderBottom: 'solid 4px transparent',
      cursor: 'pointer',
   },
   activeTab:{
      borderBottom: 'solid 4px var(--primary)',
   },
   container: {
      margin: '0 auto',
      color: '#333',
   },
   title: {
      fontSize: 24,
      marginTop: 0,
      color: '#4a5568',
   },
   toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
      flexDirection: 'row',
   },
   searchWrapper: {
      position: 'relative',
      width: 240,
   },
   searchIcon: {
      position: 'absolute',
      top: '8px',
      left: '8px',
      color: 'rgb(153, 153, 153)',
   },
   searchInput: {
      width: '100%',
      padding: '10px 9px 10px 32px',
      borderRadius: '4px',
      border: '1px solid rgb(204, 204, 204)',
      fontSize: '16px',
   },
   iconBtn: {
      cursor: 'pointer',
      fontSize: '24px',
      color: 'rgb(0, 0, 0)',
      background: '#fff',
      display: 'flex',
      padding: '5px',
      border: 'solid 1px #ccc',
   },
   statusDot: {
      display: 'inline-block',
      width: 12,
      height: 12,
      borderRadius: '50%',
      marginRight: 6,
   },
   statusText: {
      fontSize: 12,
      fontWeight: '500',
      marginRight: 6,
      verticalAlign: 'middle',
   },
   idText: {
      fontSize: 12,
      color: '#000',
      marginTop: 4,
   },
   actionBtn: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: '#555',
      marginRight: 8,
      fontSize: 18,
   },
   rightSideFilter: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
   },
};